/***
 * 返回布尔值，表示当前设备是否为移动设备
 */
function getCurrentDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}